<template>
    <div v-if="cropLocationVarietyRosters && cropLocationVarietyRosters.length > 0" :class="expanded ? 'roster-localtion-table-scroll' : 'roster-localtion-table-scroll collapsed'" id="roster-localtion-table-scroll-day">
        <table class="v-datatable v-table theme--light">
            <thead>
                <tr>
                    <th style="min-width:200px; width:15%; padding: 4px 0px; border-bottom: 1px solid rgba(0,0,0,0.12);" align="center" rowspan="2">
                        <v-layout row>
                            <v-flex shrink>
                                <v-icon v-if="expanded" dark large @click="expand(false)">expand_more</v-icon>
                                <v-icon v-if="!expanded" dark large @click="expand(true)">expand_less</v-icon>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                    class="pl-2 pr-2"
                                    label="Location"
                                    v-model="localFilterLocationVarietyName"
                                    prepend-inner-icon="search"
                                    single-line
                                    hide-details
                                    color="white"
                                    dark
                                    @keypress="expand(true)"
                                    outline>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </th>
                    <th v-for="(day, index) in days" 
                        :key="index"
                        colspan="2"
                        style="width:225x;">
                        <div class="vertical-cell">
                            <span style="font-size:large">{{ moment(day.Date).format('ddd') }}</span>
                        </div>
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12); font-size:small;" class="pa-0 font-weight-bold" rowspan="2">
                        Total Volume
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12); font-size:small;" class="pa-0 font-weight-bold" rowspan="2">
                        Var. To Forecast
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold" rowspan="2">
                        
                    </th>

                </tr>
                <tr>    
                    <th v-for="(i, index) in ((7 * 2) + (showPreviousSunday ? 2 : 0))"
                        :key="index">
                        <div class="vertical-cell" style="font-size:larger">
                            {{(i % 2) ? 'Volume' : 'Team'}}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="filteredCropLocationVarietyRosters.length == 0">
                <tr>
                    <td :colspan="18"></td>
                </tr>
            </tbody>
            <tbody v-if="loading">
                <tr>
                    <td :colspan="18" style="text-align: center;">
                        <v-container fill-height fluid>
                        <v-layout row align-center justify-center>
                            <v-progress-circular indeterminate></v-progress-circular>
                        </v-layout>
                        </v-container>
                    </td>
                </tr>
            </tbody>
            <InfiniteLoadingTableBody v-if="loading === false && filteredCropLocationVarietyRosters.length > 0" :data="filteredCropLocationVarietyRosters" :page-size="12">
                <template v-slot:rows="{ shownData }">
                    <RosterLocationTableRow
                        v-for="(item, index) in shownData" 
                        :key="index"
                        :cropLocationVarietyRoster="item"
                        @multi-update-spray="multiUpdateSpray"
                        @multi-update-team-rosters="multiUpdateTeamRosters">
                    </RosterLocationTableRow>
                </template>
                <template v-slot:footerRows>
                    <tr class="fillerRow">
                        <td v-for="i in 18" :key="i"></td>
                    </tr>
                </template>
            </InfiniteLoadingTableBody>
            <RosterLocationFooter v-if="expanded" :cropLocationVarietyRosters="cropLocationVarietyRosters" />
        </table>

    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import moment from "moment";
import RosterLocationFooter from '@/components/berriesRoster/RosterLocationFooter.vue'
import InfiniteLoadingTableBody from '@/components/generic/InfiniteLoadingTableBody.vue';
import RosterLocationTableRow from '@/components/berriesRoster/RosterLocationTableRow.vue';
import RosterUtilService from '@/services/rosterUtilService';
export default {
    components: {
        RosterLocationFooter,
        InfiniteLoadingTableBody,
        RosterLocationTableRow
    },
    props: {

    },
    data(){
        return {
            moment,
            loading: false,
            localFilterLocationVarietyName: "",
            expanded: true
        };
    },
    computed: {
        ...mapState("RosterStore", [
            "cropLocationVarietyRosters",
            "cropLocationVarietyRostersPreviousDay",
            "rosterTeamPlans",
            "localFilterTeamIDs",
            "showPreviousSunday"
        ]),
        ...mapGetters("RosterStore", [
            "days",
            "teams"
        ]),
        filteredCropLocationVarietyRosters() {
            var cropLocationVarietyRostersLocal = [];

            if(this.localFilterLocationVarietyName) {                
                cropLocationVarietyRostersLocal = this.cropLocationVarietyRosters.filter(r=> r.LocationName.toLowerCase().indexOf(this.localFilterLocationVarietyName) > -1 || r.Varieties.some(v=> v.VarietyName.toLowerCase().indexOf(this.localFilterLocationVarietyName) > -1));
            }
            else if(this.localFilterTeamIDs.length > 0) {
                cropLocationVarietyRostersLocal = this.cropLocationVarietyRosters.filter(r => {
                    if(r.IsSprayTeam && this.localFilterTeamIDs.includes(-1)){
                        return true;
                    }
                    return r.RosteredTeamIDs.some(id => this.localFilterTeamIDs.includes(id))
                })
            }
            else {
                cropLocationVarietyRostersLocal = this.cropLocationVarietyRosters;
            }

            // we are going to possibly push something into the structure below, so we can't have any reference to the original objects here,
            // because it will affect what is in the data passed in as a prop
            cropLocationVarietyRostersLocal = JSON.parse(JSON.stringify(cropLocationVarietyRostersLocal));

            var lastCropLocationVarietyRoster = null;
            for(var i = cropLocationVarietyRostersLocal.length - 1; i >= 0; i --) {
                var cropLocationVarietyRoster = cropLocationVarietyRostersLocal[i];

                cropLocationVarietyRoster.next = null;
                if(lastCropLocationVarietyRoster) {
                    cropLocationVarietyRoster.next = {CropLocationID: lastCropLocationVarietyRoster.CropLocationID, Varieties: lastCropLocationVarietyRoster.Varieties}
                }
                lastCropLocationVarietyRoster =  cropLocationVarietyRoster;
            }

            // combine the previous day data with the normal week data

            let previousDayData = [];

            if(this.localFilterLocationVarietyName) {                
                previousDayData = this.cropLocationVarietyRostersPreviousDay.filter(r => r.LocationName.toLowerCase().indexOf(this.localFilterLocationVarietyName) > -1 || r.Varieties.some(v=> v.VarietyName.toLowerCase().indexOf(this.localFilterLocationVarietyName) > -1));
            }
            else {
                previousDayData = this.cropLocationVarietyRostersPreviousDay;
            }

            for (let previousDayDatum of previousDayData) {
                previousDayDatum.IsPreviousDay = true;

                let thisWeekDataMatchingCropLocation = cropLocationVarietyRostersLocal.find(r => r.CropLocationID == previousDayDatum.CropLocationID);

                if (thisWeekDataMatchingCropLocation) {
                    for (let i=previousDayDatum.Days.length-1; i >= 0; i--) {
                        let day = previousDayDatum.Days[i];

                        day.IsPreviousDay = true;

                        /**
                         * Ultimately we are pushing a change into the cropLocationVarietyRostersLocal object, on which we used JSON parse+stringify
                         * above so that we are no longer referring back to the original objects from the cropLocationVarietyRosters prop. This should
                         * ensure we are not actually causing a modification of the original object, despite what this eslint warning is suggesting.
                         */
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        thisWeekDataMatchingCropLocation.Days.unshift(day);
                    }
                }
                else {
                    for (let day of previousDayDatum.Days) {
                        day.IsPreviousDay = true;
                    }

                    cropLocationVarietyRostersLocal.push(previousDayDatum);
                }
            }

            return cropLocationVarietyRostersLocal;
        }
    },

    methods: {
        ...mapMutations("RosterStore", [
        ]),
        ...mapActions("RosterStore", [
            "updateCropLocationVarietyRosters",
            "updateCropLocationVarietyRosters_NoReload",
            "reloadCropLocationVarietyRosters"
        ]),
        expand(status) {
            this.expanded = status;
            this.$emit("expand", status);
        },
        async multiUpdateSpray() {
            for (const locationVarRoster of this.filteredCropLocationVarietyRosters) {
                for (const day of locationVarRoster.Days) {
                    if (day.IsChecked) {
                        await this.updateCropLocationVarieties(RosterUtilService.setDaytoSpray(day));
                    }
                }
            } 
        },
        async multiUpdateTeamRosters(teamId) {
            var teamIds = [];
            var teams = [];

            if (teamId) {
                teamIds.push(teamId);
                teams.push({ teamID: teamId, TeamName: '' });
            }

            const updatePromises = [];

            for (const locationVarRoster of this.filteredCropLocationVarietyRosters) {
                for (const day of locationVarRoster.Days) {
                    const forecastValueExists = typeof day.ForecastDayValue === 'number' && day.ForecastDayValue > 0;
                    
                    if (day.IsChecked && forecastValueExists) {  
                        if (day.Varieties.length == 1 || !teamId) {
                            // standard add/remove or variety split remove
                            var allocation = RosterUtilService.addUpdateTeamRosters(day, teamIds);
                            updatePromises.push(this.updateCropLocationVarieties(allocation));
                        } else {
                            // variety split add
                            var mixedItems = RosterUtilService.generateMixedPopupItems(day, day, teams, teams, teams);
                            var varietyRosterItems = mixedItems.varietyRosterItems;
                            var splitAllocation = RosterUtilService.addUpdateMixedVarietyRosters(day, varietyRosterItems);

                            if (teamId) {
                                for (const variety of splitAllocation.Varieties) {
                                    for (const roster of variety.Rosters) {
                                        roster.teamID = teamId;
                                    }
                                }
                            }
                            
                            updatePromises.push(this.updateCropLocationVarieties(splitAllocation));
                        }
                    }
                }
            }

            //console.time('multiUpdateTeamRosters');

            this.loading = true;
            await Promise.all(updatePromises);
            await this.reloadCropLocationVarietyRosters();
            this.loading = false;

            //console.timeEnd('multiUpdateTeamRosters');
        },
        async updateCropLocationVarieties(cropLocationVarieties) {
            try {
                await this.updateCropLocationVarietyRosters_NoReload(cropLocationVarieties);
            } catch(e) {
                this.error = e.toString();
            }
        }
    },
    created(){
        
    }
}
</script>

<style scoped>
.vertical-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.row {
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.roster-localtion-table-scroll {
    position: absolute;
    z-index: 1;
    overflow: auto;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    min-height: 100px;
}

.roster-localtion-table-scroll.collapsed {
    min-height: 0px;  
    max-height:80px;
    overflow: hidden;
}

.roster-localtion-table-scroll table {
    width: 100%;
    height: 100%;
    margin: auto;
}

.roster-localtion-table-scroll table tr td, .roster-localtion-table-scroll table tr th {
    width: auto;
}

.roster-location-table-scroll thead {
    background-color: #449144 ;
}

.roster-localtion-table-scroll thead tr td, .roster-localtion-table-scroll thead tr th {
    position: -webkit-sticky;
    position: sticky;
    z-index: 5;
    background-color: #449144 ;
    z-index: 5;
    color: white;
}

.roster-localtion-table-scroll thead tr:nth-child(1) td, .roster-localtion-table-scroll thead tr:nth-child(1) th {
    top: 0px;
    height: 40px!important;
    max-height: 40px;
    min-height: 40px;
}

.roster-localtion-table-scroll thead tr:nth-child(2)  {
    height: 20px;
}

.roster-localtion-table-scroll thead tr:nth-child(2) td, .roster-localtion-table-scroll thead tr:nth-child(2) th {
    top: 55.56px;
    height: 20px;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-child(1) {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 25;
}

 
.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(1) {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 25;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(2) {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 100;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(3) {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 100;
}

.roster-localtion-table-scroll .fillerRow th, .fillerRow td {
    height: auto;
}

.roster-localtion-table-scroll .v-table thead tr:first-child {
    border-bottom: none;
}

.roster-localtion-table-scroll .v-table thead tr:nth-child(2) {
    border-bottom: 1px solid rgba(0,0,0,0.12);
}
.roster-localtion-table-scroll .leftBorder {
    border-left: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 75px;
    max-width: 75px;
    width: 75px;
}

.roster-localtion-table-scroll .rightBorder {
    border-right: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 125px;
    max-width: 125px;
    widows: 125px;;
}
.roster-localtion-table-scroll .small-cell {
        min-height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

 .locationColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 10;
    background: white;
}

.totalVarToForecastColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 10;
    background: white; 
}

.totalVolumeColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 10;
    background: white; 
}

.totalEmptyColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 10;
    background: white; 
}

.teamTopSection {
    position: sticky;
    top: 4px;
    left: 0;
    right: 0;
    z-index: 99;
    background: white;
}
</style>